import {
	VelocityClient,
	UserAccount,
	UserStatsAccount,
} from '@velocity-exchange/sdk';
import { Vault, VaultClient } from '@velocity-exchange/vaults-sdk';

export const vaultDataDecoder = (
	buffer: Buffer,
	vaultProgram: VaultClient['program']
): Vault => {
	const account = vaultProgram.account.vault.coder.accounts.decode(
		'vault',
		buffer
	);
	return account;
};

export const userStatsDataDecoder = (
	buffer: Buffer,
	velocityProgram: VelocityClient['program']
): UserStatsAccount => {
	// The new velocity-exchange SDK exposes a deeply-parameterized `Program`
	// type that triggers TS2589 ("type instantiation excessively deep") when
	// the strict types are followed end-to-end. Cast through `any` to break
	// the recursion before invoking the decoder.
	const program: any = velocityProgram;
	return program.account.userStats.coder.accounts.decodeUnchecked(
		'userStats',
		buffer
	) as UserStatsAccount;
};

export const userAccountDataDecoder = (
	buffer: Buffer,
	velocityProgram: VelocityClient['program']
): UserAccount => {
	// See note in `userStatsDataDecoder` re: TS2589.
	const program: any = velocityProgram;
	return program.account.user.coder.accounts.decodeUnchecked(
		'user',
		buffer
	) as UserAccount;
};
